import _asyncToGenerator from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/regenerator/index.js";
// boot/router.js
var routerInstance = void 0;
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var router;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          router = _ref.router;
          // something to do
          routerInstance = router;
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();
export { routerInstance };